module.exports = __webpack_public_path__ + "f6c2164baa4e31746e0d3a9cade5e068.svg";